import React, { useEffect, useRef, useState } from 'react'
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { BaseConfig } from '../BaseConfig';

class WelcomeWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'bg',
				src: process.env.PUBLIC_URL + '/assets/login/startupscreen.jpg'
			}
		];
	}
}

export const welcomeWindowCaching = new WelcomeWindowCaching();

const WelcomeWindow = (props: WelcomeWindowConfig) => {
	const [clicked, setClicked] = useState(false)
	return (
		<div className='w-full h-full' tabIndex={0} aria-label='Welcome Window' style={{
			pointerEvents: clicked ? 'none' : 'all'
		}}>
			<img className='w-full h-full' src={welcomeWindowCaching.getItemByKey('bg').src} alt="" />
			<div style={{
				position: 'absolute',
				top: '0',
				left: '0'
			}}>
				<div style={{
					position: 'absolute',
					top: '256px',
					left: '450px',
					width: '1020px',
					height: '343px',
					// backgroundColor: 'rgba(0,0,255,0.5)',
				}} id="welcome-page-start" tabIndex={0} aria-label='Welcome to 360 degrees visual inspection of a structure. Interactive training series'></div>
			</div>
			<div className='absolute left-[653px] top-[686px] w-[612px] h-[114px] cursor-pointer' tabIndex={0} role='button' id='welcome-page-end' aria-label='click here to begin' onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
				setClicked(true)
				if(props.onClickHereToBeginClicked) {
					props.onClickHereToBeginClicked()
				}
			}}>

			</div>
		</div>
	);

};

export interface WelcomeWindowConfig extends BaseConfig {
	onClickHereToBeginClicked: () => void;
}

export default WelcomeWindow;